@if (loading) {
    <div class="w-full h-[400px] animate-pulse bg-dat-grey-200"></div>
}
<div #graph [id]="rootId()" class="border border-solid border-dat-grey-100 rounded w-full h-[400px]" [ngClass]="{'!h-0': loading}"></div>
